export function translateStockTerm(stock, translatorStepKey, inconsistency, schema, translationItem) {
    if (stock[translatorStepKey] === inconsistency[translatorStepKey] && !stock.hasNonEquivalence) {
      const metadataHasSameValue = schema[translatorStepKey].metadata.every(
        metadataKey => {
          return stock[metadataKey] === inconsistency[metadataKey]
        }
      )
      if (metadataHasSameValue) {
        stock[translatorStepKey] = translationItem ? translationItem.name : inconsistency[translatorStepKey]
        stock.hasNonEquivalence =  !translationItem
      }
    }
  }